import * as React from 'react';
import * as cx from 'classnames';
import { NavClick } from '../../../store/action/primaryNavActions';
import './NavItem.css';

interface Props {
    onClick: NavClick;
    activeId: string;
    id: string;
    disabled: boolean;
    title?: string;
}

function isActive(navId: string, id: string) {
    return navId === id;
}

function getClasses(navId: string, id: string, disabled: boolean) {
    let active = isActive(navId, id);
    return cx({
        'nav-item': true,
        'nav-flex-item': true,
        'nav-active': active,
        'nav-inactive': !active,
        'nav-disabled': disabled
    });
}

class NavItem extends React.Component<Props> {
    render() {
        const { onClick, activeId, id, children, disabled, title } = this.props;

        return (
            <li className={getClasses(activeId, id, disabled)}>
                <a
                    onClick={(e) => onClick(id)}
                >
                    {children ? children : title || ''}
                </a>
            </li>
        );
    }
}

export default NavItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/nav/topNav/NavItem.tsx